import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import Link from '../link';

const Mode06Container = () => {
  const pdfs = [
    {
      name: 'MY01-02 B5244T B5234T - S60 C70',
      url: 'https://cdn.volvotechinfo.com/resources/mode06/MY01-02B5244TB5234T-S60C70.pdf',
    },
    {
      name: 'MY01-04 B5244S - V70 S60',
      url: 'https://cdn.volvotechinfo.com/resources/mode06/MY01-04B5244S-V70S60.pdf',
    },
    {
      name: 'MY04 B5254T2 - S40',
      url: 'https://cdn.volvotechinfo.com/resources/mode06/MY04B5254T2-S40.pdf',
    },
    {
      name: 'MY04-05 B5254T B5244T B6294TS - S60 V/XC70 XC90',
      url: 'https://cdn.volvotechinfo.com/resources/mode06/MY04-05B5254TB5244TB6294TS-S60VXC70XC90.pdf',
    },
    {
      name: 'MY04-07 B5244S - S40 V50 C30',
      url: 'https://cdn.volvotechinfo.com/resources/mode06/MY04-07B5244S-S40V50C30.pdf',
    },
    {
      name: 'MY05-07 B5254T - S40 V50 C70 C30',
      url: 'https://cdn.volvotechinfo.com/resources/mode06/MY05-07B5254T-S40V50C70C30.pdf',
    },
    {
      name: 'MY06-07 B5254T B5244T - S60 V/XC70 XC90',
      url: 'https://cdn.volvotechinfo.com/resources/mode06/MY06-07B5254TB5244T-S60VXC70XC90.pdf',
    },
    {
      name: 'MY07 B6324S - S80 XC90 AWD',
      url: 'https://cdn.volvotechinfo.com/resources/mode06/MY07B6324S-S80XC90AWD.pdf',
    },
  ];

  return (
    <section className="mode06-container">
      <h2>Mode $06 Information</h2>
      <div className="pdf-container">
        <ul>
          {pdfs.map((pdf, index) => (
            <li key={index}>
              <Link href={pdf.url}>
                <FontAwesomeIcon icon={faDownload} /> {pdf.name}
              </Link>
            </li>
          ))}
        </ul>
      </div>
      {/* language=CSS */}
      <style jsx>{`
        .mode06-container {
          font-family: 'Volvo Novum', sans-serif;
        }

        .mode06-container h2 {
          font-weight: 400;
          margin: 0;
        }

        .pdf-container > ul {
          list-style: none;
          padding: 0;
        }

        .pdf-container > ul li {
          display: block;
          padding-bottom: 1rem;
        }

        .mode06-container :global(a) {
          color: #333;
          text-decoration: none;
        }

        .mode06-container :global(a:hover) {
          color: #707070;
        }
      `}</style>
    </section>
  );
};

export default Mode06Container;
